import _ from 'lodash';
import Tone from 'tone';
import settingSaver from './setting-saver';

export default function(name, ToneSynth, userDefaults) {
  const storageName = 'synth.' + name;
  const synth = new Tone.PolySynth(10, () => (
    new ToneSynth(
      Object.assign({}, userDefaults, settingSaver.get(storageName))
    )
  ));

  synth.setAttribute = function(attribute, value) {
    if (_.isUndefined(attribute) || _.isUndefined(value)) {
      throw new Error('Missing parameter')
    };

    const keys = attribute.split('.');
    const parentName = keys[0];
    const parentData = Object.assign({}, synth.get(parentName)[parentName]);
    parentData[keys[1]] = value;

    synth.set(keys[1], value);
    settingSaver.set(storageName, synth.get());
  }

  synth.resetSettings = function() {
    settingSaver.set(storageName, {});
    window.location.reload();
  }

  return synth;
}



// WEBPACK FOOTER //
// ./src/synth.js